module.exports = __webpack_public_path__ + "img/pizza-slice.b66f6741.png";